// The inventory-count API returns only warehouse_id. Resolve the display name
// from the location master the route already loads, falling back to the ID.
export function inventoryCountLocationName(count, warehouses) {
    if (!count) return "-"
    if (count.warehouse_name || count.location_name) return count.warehouse_name || count.location_name
    const id = String(count.warehouse_id ?? "")
    const warehouse = (Array.isArray(warehouses) ? warehouses : []).find((entry) => String(entry?.id) === id)
    return warehouse?.name || warehouse?.title || id || "-"
}
